import axios from 'axios';
import {
  emotionServer,
  menuDataServer,
  twilioServer,
  server,
  pythonServer,
  agenticServer,
  windmillApiAuthKey,
  outboundCallServer,
  agentLightingServer,
} from '../../constants';
import {
  ILoginCredentials,
  IGoogleLoginCredentials,
  ISignupCredentials,
  IForgotPasswordCredentials,
  IResetPasswordCredentials,
  queryKeyParams,
  IUploadOutboundFile,
  IGetOutboundFilesParams,
  IUpdateOutboundFileMapping,
  IGetOutboundFileDataParams,
  ITriggerCall,
  ITriggerSingleOutboundCall,
  IScheduleOutboundCall,
  PaginationQuery,
  Template,
  IUpdateAssistantConfigValues,
  IUpdateAssistant,
  IUpdateAgentPhoneAccountType,
  IConnectWhatsappVoiceLink,
  IDisconnectWhatsappVoiceLink,
  IAgentCallsMetrics,
  IAgentCallsData,
  IChatDataApiParams,
  IUpdateEventsFunction,
  IGenerateExtractor,
  ISaveExtractor,
  ITalkToTwilio,
  IOutboundCall,
  IDownloadCSV,
  IGetExtractionData,
  IUpdateAgentVoice,
  IAssignNumberToAgent,
  ICreateOrganization,
  IJoinOrganization,
  IInviteUser,
  IAcceptInvite,
  IRemoveUser,
  IVersionHistoryParams,
  IAddLabelToVersion,
  IUseSystemPrompt,
  IUpdateAgent,
  CallStageData,
  BlankAgent,
  ISaveAssistantSteps,
  ICreateBusiness,
  ICreateStore,
  IgetMenuData,
  IGetOrdersParams,
  IGoogleLocationGeocodeParams,
  ISignupParams,
  ICreateBrand,
  ICreateStoreContcat,
  IBusinessCreate,
  ICreateStoreV2,
  IStoreSchedule,
  IStoreKnowledgeRequest,
  ISaveStore,
  AgentChatSimulation,
  ICreateFunction,
  ICreateWebForm,
  ISaveWhatsappDetails,
  ISaveConversationFlow,
  UltravoxToolDefinition,
  HideSectionsConfig,
  IScheduleUvOutboundCall,
  IGoogleDriveConfigPayload,
  IProcessCallEvaluation,
  ISaveAudioEvaluation,
  IGetAudioEvaluationFiles,
  ISaveCallForwardingRules,
  IUpdateEvalConfigPrompts,
  IBillingConfig,
  IInvoiceQuery,
  IGenerateInvoice,
  IUpdateInvoiceStatus,
} from '../../schemas/apis/interface';
import jwtInterceptor from './jwtinterceptor';

export const signupApi = (formData: ISignupCredentials) => {
  return axios.post(`${server}/auth/signup`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const loginApi = (formData: ILoginCredentials) => {
  return axios.post(`${server}/auth/login`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const googleLoginApi = (formData: IGoogleLoginCredentials) => {
  return axios.post(`${server}/auth/google-login`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const forgotPasswordApi = (formData: IForgotPasswordCredentials) => {
  return axios.post(`${server}/auth/forgotPassword`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const resetPasswordApi = (formData: IResetPasswordCredentials) => {
  return axios.put(`${server}/auth/resetPassword/${formData.token}`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const logoutApi = () => {
  return axios.post(`${server}/auth/logout`, {}, { withCredentials: true });
};

export const getUserApi = () => {
  const token = localStorage.getItem('userToken');
  return jwtInterceptor.get(`${server}/auth/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
  });
};

export const upgradeAccountApi = () => {
  const token = localStorage.getItem('userToken');
  return jwtInterceptor.patch(
    `${server}/auth/upgrade-account`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    }
  );
};

// Verify User API
export const verifyUserApi = () => {
  return jwtInterceptor.get(`${server}/auth/verify`, {
    withCredentials: true,
  });
};

// Get All Agents
// export const getAllAgents = () => {
//   return jwtInterceptor.get(`${server}/agent/all`, {
//     withCredentials: true,
//   });
// };

// Get Templates for create assistant
export const getTemplatesApi = () => {
  return jwtInterceptor.get(`${server}/agent/template/systemPrompt`, {
    withCredentials: true,
  });
};

// Get Deploy Agent API
export const getDeployAgentApi = ({ queryKey }: queryKeyParams) => {
  const agentId = queryKey[1];
  return jwtInterceptor.get(
    `${server}/agent-key/get-agent-url?agentId=${agentId}`,
    {
      withCredentials: true,
    }
  );
};

// Get Agent Config Values
export const getConfigValues = () => {
  return jwtInterceptor.get(`${server}/config/values`, {
    withCredentials: true,
  });
};

export const uploadOutboundFileApi = ({
  file,
  agentId,
}: IUploadOutboundFile) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('agentId', agentId);
  return jwtInterceptor.post(
    `${server}/outbound-call/upload-outbound-config`,
    formData,
    {
      withCredentials: true,
    }
  );
};

export const getOutboundFiles = ({ queryKey }: IGetOutboundFilesParams) => {
  const { agentId, page, limit, fileType } = queryKey[1];
  const params = new URLSearchParams({
    agentId,
    page: page.toString(),
    limit: limit.toString(),
  });
  if (fileType) {
    params.append('fileType', fileType);
  }
  return jwtInterceptor.get(
    `${server}/outbound-call/outbound-file?${params.toString()}`,
    { withCredentials: true }
  );
};

export const deleteOutboundFileApi = (id: string) => {
  return jwtInterceptor.delete(
    `${server}/outbound-call/outbound-file?_id=${id}`,
    {
      withCredentials: true,
    }
  );
};

export const updateOutboundFileMappingApi = ({
  outboundFileId,
  fieldMapping,
  phoneNumber,
}: IUpdateOutboundFileMapping) => {
  return jwtInterceptor.post(
    `${server}/outbound-call/outbound-file-mapping`,
    {
      outboundFileId,
      fieldMapping,
      phoneNumber,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const downloadOutboundRecordsApi = (outboundConfigFileId: string) => {
  return jwtInterceptor.get(`${server}/outbound-call/download-records`, {
    params: { outboundConfigFileId },
    withCredentials: true,
  });
};

export const getOutboundFileData = ({
  outboundFileId,
  page,
  limit,
}: IGetOutboundFileDataParams) => {
  return jwtInterceptor.get(
    `${server}/outbound-call/outbound-file-data?outboundFileId=${outboundFileId}&page=${page}&limit=${limit}`,
    {
      withCredentials: true,
    }
  );
};

export const triggerCallApi = ({
  user_number,
  twilio_number,
  agentId,
  callData,
  recordId,
  provider,
}: ITriggerCall) => {
  return jwtInterceptor.post(
    `${server}/create/call`,
    {
      user_number,
      twilio_number,
      agentId,
      callData,
      recordId,
      provider,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const triggerSingleOutboundCall = ({
  key,
  DESTINATION_PHONE_NUMBER,
  UserName,
}: ITriggerSingleOutboundCall) => {
  return axios.get(`${outboundCallServer}/getOutboundCall`, {
    params: {
      key,
      DESTINATION_PHONE_NUMBER,
      UserName,
    },
  });
};

export const scheduleOutboundCallApi = (formData: IScheduleOutboundCall) => {
  return jwtInterceptor.post(`${server}/outbound-call/schedule`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// Get Extraction Data
export const getAgentAppointments = ({
  agentId,
  pageNo,
  pageSize,
}: PaginationQuery) => {
  return jwtInterceptor.get(`${server}/agent/appointment`, {
    params: { agentId, pageNo, pageSize },
    withCredentials: true,
  });
};

// Create Agent
export const createAgentApi = (formData: Template) => {
  return jwtInterceptor.post(`${server}/agent/create`, formData, {
    withCredentials: true,
  });
};

// Get Timezone Values
export const getTimezoneValues = () => {
  return jwtInterceptor.get(`${server}/timeZone/getAll`, {
    withCredentials: true,
  });
};

// Update Assistant Config Values
export const updateAssistantConfigValues = ({
  agentId,
  llm,
  tts,
  stt,
  audio = true,
  chat = true,
  filler = false,
  transcript = true,
  timeZone,
  responseDelay = 2.5,
  voice,
  language,
  latency,
  stability,
  speed,
  similarity,
  variables,
  noiseSuppression,
  warmTransfer,
  userTimeout,
  vad,
  whatsappConfig,
  tools,
}: IUpdateAssistantConfigValues) => {
  const params = new URLSearchParams({
    agentId,
    llm,
    tts,
    stt,
    audio: audio.toString(),
    chat: chat.toString(),
    filler: filler.toString(),
    transcript: transcript.toString(),
    timeZone,
    voice,
    language,
    latency: latency?.toString() || '',
    stability: stability?.toString() || '',
    speed: speed?.toString() || '',
    similarity: similarity?.toString() || '',
    responseDelay: responseDelay.toString(),
    noiseSuppression: noiseSuppression?.toString() || '',
    warmTransfer: warmTransfer?.toString() || '',
    userTimeout: userTimeout?.toString() || '',
  });

  const requestBody: any = {
    variables,
    vad,
  };

  // Add whatsappConfig to request body if it exists
  if (whatsappConfig) {
    requestBody.whatsappConfig = whatsappConfig;
  }

  // Add tools to request body if it exists
  if (tools) {
    requestBody.tools = tools;
  }

  return jwtInterceptor.put(
    `${server}/agent/config/update?${params.toString()}`,
    requestBody,
    {
      withCredentials: true,
    }
  );
};

// Update Agent
export const updateAgentApi = (formData: IUpdateAssistant) => {
  return jwtInterceptor.post(`${server}/agent/update`, formData, {
    withCredentials: true,
  });
};

export const updateAgentPhoneAccountTypeApi = (
  formData: IUpdateAgentPhoneAccountType
) => {
  return jwtInterceptor.post(`${server}/agent/update`, formData, {
    withCredentials: true,
  });
};

export const connectWhatsappVoiceLinkApi = (data: IConnectWhatsappVoiceLink) =>
  jwtInterceptor.post(`${server}/agent/whatsapp-voice-link/connect`, data, {
    withCredentials: true,
  });

export const disconnectWhatsappVoiceLinkApi = (
  data: IDisconnectWhatsappVoiceLink
) =>
  jwtInterceptor.post(`${server}/agent/whatsapp-voice-link/disconnect`, data, {
    withCredentials: true,
  });

// Update Events Function
export const updateEventsFunctionApi = (formData: IUpdateEventsFunction) => {
  return jwtInterceptor.post(`${server}/agent/update-events`, formData, {
    withCredentials: true,
  });
};

// Generate Extractor
export const generateExtractorApi = (formData: IGenerateExtractor) => {
  return jwtInterceptor.post(
    `${server}/extractor/suggest`,
    {
      description: formData.description,
      jsonSchema: formData.jsonSchema,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      withCredentials: true,
    }
  );
};

// Save Extractor
export const saveExtractorApi = (extractData: ISaveExtractor) => {
  return jwtInterceptor.post(
    `${server}/extractor/confirmSchema`,
    {
      agentId: extractData.agentId,
      name: extractData.name,
      jsonSchema: extractData.schema,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      withCredentials: true,
    }
  );
};

// Get Agent Calls Metrics
export const getAgentCallsMetrics = ({
  agentId,
  fromDate,
  toDate,
}: IAgentCallsMetrics) => {
  return jwtInterceptor.post(
    `${server}/stats/total_cost`,
    {
      agentId: agentId,
      fromDate: fromDate,
      toDate: toDate,
    },
    {
      withCredentials: true,
    }
  );
};

// Get Agent Calls Data
export const getAgentCallsData = ({
  agentId,
  limit = 10,
  page,
  fromDate,
  toDate,
}: IAgentCallsData) => {
  return jwtInterceptor.get(
    `${server}/history/chatData?page=${page}&agentId=${agentId}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      withCredentials: true,
    }
  );
};

// Get Chat Data
export const getChatDataApi = ({ id }: IChatDataApiParams) => {
  return jwtInterceptor.get(`${server}/history/chat?chatId=${id}`, {
    withCredentials: true,
  });
};

export const talkToTwilioApi = (formData: ITalkToTwilio) => {
  const postBody = {
    ...formData,
  };

  return jwtInterceptor.post(`${twilioServer}/call/telnyx`, postBody, {
    withCredentials: true,
  });
};

export const createOutboundCall = (formData: IOutboundCall) => {
  return axios.get(`${outboundCallServer}/getOutboundCall`, {
    params: {
      key: formData.agentKey,
      DESTINATION_PHONE_NUMBER: formData.phoneNumber,
      UserName: formData.userName,
    },
  });
};

export const getPlivoOutboundCall = (formData: IOutboundCall) => {
  return axios.get(`${outboundCallServer}/getOutboundCallPlivo`, {
    params: {
      key: formData.agentKey,
      DESTINATION_PHONE_NUMBER: formData.phoneNumber,
      UserName: formData.userName,
    },
  });
};

export const addToBlacklist = ({
  phoneNumber,
  reason,
}: {
  phoneNumber: string;
  reason: string;
}) => {
  return jwtInterceptor.post(
    `${server}/blacklist/add`,
    { phoneNumber, reason },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
};

export const removeFromBlacklist = ({
  phoneNumber,
}: {
  phoneNumber: string;
}) => {
  return jwtInterceptor.post(
    `${server}/blacklist/remove`,
    { phoneNumber },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
};

export const downloadCSV = ({ agentId, fromDate, toDate }: IDownloadCSV) => {
  return jwtInterceptor.post(
    `${server}/stats/download_calls_csv`,
    { agentId, fromDate, toDate },
    { withCredentials: true }
  );
};

export const getExtractionDataApi = ({ sid, token }: IGetExtractionData) => {
  return jwtInterceptor.post(
    `${server}/pipe-cat/call-end-extraction`,
    {
      callSid: sid,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    }
  );
};

export const deleteAgentApi = (agentId: string) => {
  return jwtInterceptor.delete(`${server}/agent/delete`, {
    data: { agentId },
    withCredentials: true,
  });
};

interface IGetAllVoicesParams {
  service: string;
}

// Get All Voices
export const getAllVoices = ({ service }: IGetAllVoicesParams) => {
  return jwtInterceptor.get(`${server}/voices/get-voices?service=${service}`, {
    withCredentials: true,
  });
};

export const updateAgentVoiceApi = (formData: IUpdateAgentVoice) => {
  return jwtInterceptor.post(`${server}/agent/update-voice-lab`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const uploadKnowledgeBaseFileApi = ({
  file,
  storeId,
  userId,
}: {
  file: File;
  storeId: string;
  userId: string;
}) => {
  const formData = new FormData();
  formData.append('file', file);
  return jwtInterceptor.post(
    `${pythonServer}/upload-file/${userId}/${storeId}`,
    formData,
    {
      headers: {
        accept: 'application/json',
      },
      withCredentials: true,
    }
  );
};

// Get Knowledge Base Files
export const getKnowledgeBaseFiles = (storeId: string) => {
  return jwtInterceptor.get(`${server}/upload/get-file?storeId=${storeId}`, {
    withCredentials: true,
  });
};

// delete knowdledge base file
export const deleteKnowledgeBaseFile = (
  userId: string,
  storeId: string,
  filename: string
) => {
  return jwtInterceptor.delete(`${pythonServer}/delete`, {
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
    data: {
      user_id: userId,
      store_id: storeId,
      filename: filename,
    },
  });
};

// assign phone number to agent
export const assignPhoneToAgentApi = (formData: IAssignNumberToAgent) => {
  return jwtInterceptor.post(
    `${server}/numbers/assignAgentToPhoneNumber`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// create organization
export const createOrganizationApi = (formData: ICreateOrganization) => {
  return jwtInterceptor.post(
    `${server}/organization/create-organization`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// join organization
export const joinOrganizationApi = (formData: IJoinOrganization) => {
  return jwtInterceptor.post(
    `${server}/organization/join-organization`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// invite user to organization
export const inviteUserApi = (formData: IInviteUser) => {
  return jwtInterceptor.post(`${server}/organization/invite-user`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// accept organization invite (no auth required)
export const acceptInviteApi = (formData: IAcceptInvite) => {
  return axios.post(`${server}/organization/accept-invite`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// remove user from organization
export const removeUserApi = (formData: IRemoveUser) => {
  return jwtInterceptor.post(`${server}/organization/remove-user`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// update member sections (permissions)
export const updateMemberSectionsApi = (formData: IInviteUser) => {
  return jwtInterceptor.put(
    `${server}/organization/update-member-sections`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// get organization
export const getOrganization = () => {
  return jwtInterceptor.get(`${server}/organization`, {
    withCredentials: true,
  });
};

// get available variables
export const getAvailableVariables = (agentId: string) => {
  return jwtInterceptor.get(
    `${server}/agent/extractorVariables?agentId=${agentId}`,
    {
      withCredentials: true,
    }
  );
};

export const getCallAnalysisDataApi = ({ chatId }: { chatId: string }) => {
  return jwtInterceptor.get(`${emotionServer}/analysis/call?chatId=${chatId}`, {
    withCredentials: true,
  });
};

// Get version history
export const getPromptVersionHistoryApi = ({
  agentId,
  fromDate,
  toDate,
}: IVersionHistoryParams) => {
  return jwtInterceptor.get(
    `${server}/agent/systemPrompt/version?agentId=${agentId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      withCredentials: true,
    }
  );
};

// add lables to version
export const addLabelToVersionApi = (formData: IAddLabelToVersion) => {
  return jwtInterceptor.post(
    `${server}/agent/systemPrompt/version/add_label`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// set version history to use
export const useSystemPromptApi = ({
  versionId,
  agentId,
}: IUseSystemPrompt) => {
  return jwtInterceptor.post(
    `${server}/agent/systemPrompt/use`,
    { versionId, agentId },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

//  update version history
export const updateVersionHistoryPromptApi = (formData: IUpdateAgent) => {
  return jwtInterceptor.post(`${server}/agent/update`, formData, {
    withCredentials: true,
  });
};

// get data of calls of graphs
export const getCallAnalyticsDataApi = ({
  filter,
  agentId,
  startDate,
  endDate,
}: {
  filter?: string;
  agentId: string;
  startDate?: string;
  endDate?: string;
}) => {
  const queryParams = new URLSearchParams();

  if (startDate && endDate) {
    queryParams.append('startDate', startDate);
    queryParams.append('endDate', endDate);
  } else if (filter) {
    queryParams.append('filter', filter);
  }

  return jwtInterceptor.get(
    `${server}/analytics/call-count?${queryParams.toString()}&agentId=${agentId}`,
    {
      withCredentials: true,
    }
  );
};

// get call flow data for graphs
export const getCallFlowAnalyticsDataApi = ({
  filter,
  agentId,
  startDate,
  endDate,
}: {
  filter?: string;
  agentId: string;
  startDate?: string;
  endDate?: string;
}) => {
  const queryParams = new URLSearchParams();

  if (startDate && endDate) {
    queryParams.append('startDate', startDate);
    queryParams.append('endDate', endDate);
  } else if (filter) {
    queryParams.append('filter', filter);
  }

  return jwtInterceptor.get(
    `${server}/analytics/call_flow/${agentId}?${queryParams.toString()}`,
    {
      withCredentials: true,
    }
  );
};

// get call flow data for graphs
export const getAssistantActivityAnalyticsDataApi = ({
  filter,
  agentId,
  startDate,
  endDate,
}: {
  filter?: string;
  agentId: string;
  startDate?: string;
  endDate?: string;
}) => {
  const queryParams = new URLSearchParams();

  if (startDate && endDate) {
    queryParams.append('startDate', startDate);
    queryParams.append('endDate', endDate);
  } else if (filter) {
    queryParams.append('filter', filter);
  }

  return jwtInterceptor.get(
    `${server}/analytics/assistant_activity/${agentId}?${queryParams.toString()}`,
    {
      withCredentials: true,
    }
  );
};

//  update version history
export const defineCallAnalyticStagesApi = (formData: CallStageData) => {
  return jwtInterceptor.post(`${server}/call-stages/call-stages`, formData, {
    withCredentials: true,
  });
};

// Quibble Restaurant APIs

// get landing page templates
export const getLandingPageTemplatesApi = () => {
  return jwtInterceptor.get(`${server}/template`, {
    withCredentials: true,
  });
};

// Create Blank Assistant
export const createBlankAssistantApi = (formData: BlankAgent) => {
  return jwtInterceptor.post(`${server}/assistant/create-blank`, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  });
};

// Get all assistants
export const getAllAssistantsApi = () => {
  return jwtInterceptor.get(`${server}/assistant/get-all`, {
    withCredentials: true,
  });
};

// Save Assistant Steps

export const saveAssistantStepsApi = (
  formData: Partial<ISaveAssistantSteps>
) => {
  return jwtInterceptor.post(`${server}/assistant/create`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// Create Business
export const createBusinessApi = (formData: ICreateBusiness) => {
  return jwtInterceptor.post(`${server}/business/create`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// Create Store
export const createStoreApi = (formData: ICreateStore) => {
  return jwtInterceptor.post(`${server}/business/store-create`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// Get All Brands
export const getAllBrandsApi = ({ id }: { id: string }) => {
  return jwtInterceptor.get(`${server}/brand/get?id=${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// Get All Stores
export const getAllStoresApi = () => {
  return jwtInterceptor.get(`${server}/business/get-stores`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// Get Sample voices

export const getSampleVoicesApi = () => {
  return jwtInterceptor.get(`${server}/sample-router/getsamplevoice`, {
    withCredentials: true,
  });
};

// Connect Business
export const connectBusinessApi = (businessId: string) => {
  return jwtInterceptor.post(
    `${server}/business/connect`,
    `businessId=${businessId}`,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      withCredentials: true,
    }
  );
};

// Get Menu Data URL

export const getMenuDataUrlApi = ({
  folderPath,
  fileName,
  tenantName,
}: IgetMenuData) => {
  return jwtInterceptor.post(
    `${menuDataServer}/s3/generate-s3-url`,
    {
      bucket_name: 'quibble-client',
      folder_path: folderPath,
      file_name: fileName,
    },
    {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Tenant-Name': tenantName,
      },
      withCredentials: true,
    }
  );
};

// Get Publush data

export const getPublishEventsApi = ({
  tenantName,
  storeId,
}: {
  tenantName: string;
  storeId: string;
}) => {
  return jwtInterceptor.get(`${server}/ecl/status/${tenantName}/${storeId}`, {
    headers: {
      accept: 'application/json',
      'X-Tenant-Name': tenantName,
    },
    withCredentials: true,
  });
};

export const getGoogleLocations = ({
  query,
  lat,
  lng,
}: {
  query: string;
  lat?: string;
  lng?: string;
}) => {
  return jwtInterceptor.get(`${server}/google-locations`, {
    params: { query, ...(lat && { lat }), ...(lng && { lng }) },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getOrdersApi = ({
  skip,
  limit,
  startDate,
  endDate,
  tenantName,
  userId,
}: IGetOrdersParams) => {
  return jwtInterceptor.get(`${server}/orders/`, {
    params: {
      skip,
      limit,
      userId,
      start_date: startDate,
      end_date: endDate,
    },
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Tenant-Name': tenantName,
    },
    withCredentials: true,
  });
};

export const getGoogleLocationsGeocode = ({
  query,
}: IGoogleLocationGeocodeParams) => {
  return jwtInterceptor.get(`${server}/google-locations-geocode`, {
    params: { query },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getGooglePlaceDetails = ({ placeId }: { placeId: string }) => {
  return jwtInterceptor.get(`${server}/google-place-details/${placeId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const signupJourneyApi = (signupData: ISignupParams) => {
  return jwtInterceptor.post(`${server}/auth/signup`, signupData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const verifyMail = ({ queryKey }: queryKeyParams) => {
  const token = queryKey[1];
  return axios.post(`${server}/auth/verification/${token}`);
};

export const checkEmailApi = (email: string) => {
  return jwtInterceptor.post(
    `${server}/auth/check-email`,
    { email },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// create brand
export const createBrandApi = (formData: ICreateBrand, tenantName: string) => {
  return jwtInterceptor.post(`${server}/brands`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

// Delete Brand
export const deleteBrandApi = (brandId: string, tenantName: string) => {
  return jwtInterceptor.delete(`${server}/brands/${brandId}`, {
    headers: {
      'x-tenant-name': tenantName,
    },
  });
};

// Get All Brands
export const getAllBrandsApiV2 = (tenantName: string) => {
  return jwtInterceptor.get(`${server}/brands`, {
    headers: {
      'x-tenant-Name': tenantName,
    },
    withCredentials: true,
  });
};

// Get All Brands
export const updateBrandsApiV2 = (
  formData: ICreateBrand,
  tenantName: string,
  brandId: string
) => {
  return jwtInterceptor.put(`${server}/brands/${brandId}`, formData, {
    headers: {
      'x-tenant-Name': tenantName,
    },
    withCredentials: true,
  });
};

export const createRestaurantContactApi = (
  formData: ICreateStoreContcat,
  tenantName: string,
  business_id: string
) => {
  return jwtInterceptor.post(
    `${server}/restaurants/${business_id}/contacts`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-tenant-name': tenantName,
      },
      withCredentials: true,
    }
  );
};

// update Restaurant
export const updateRestaurant = (
  formData: IBusinessCreate,
  tenantName: string,
  businessId: string
) => {
  return jwtInterceptor.put(`${server}/restaurants/${businessId}`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

// get business
export const getRestaurantApi = (tenantName: string) => {
  return jwtInterceptor.get(`${server}/restaurants`, {
    headers: {
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

export const createStoreApiV2 = (
  formData: ICreateStoreV2,
  tenantName: string
) => {
  return jwtInterceptor.post(`${server}/stores`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

// update store
export const updateStoreApi = (
  formData: ICreateStoreV2,
  tenantName: string,
  storeId: string
) => {
  return jwtInterceptor.put(`${server}/stores/${storeId}`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-name': tenantName,
    },
  });
};

export const getStoresApi = (tenantName: string, page = 0, limit = 100) => {
  const skip = page * limit;
  return jwtInterceptor.get(`${server}/stores`, {
    params: {
      skip,
      limit,
    },
    headers: {
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

export const createStoreHours = (
  formData: IStoreSchedule,
  store_id: string,
  tenantName: string
) => {
  return jwtInterceptor.post(
    `${server}/opening-hours/stores/${store_id}/opening-hours`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-tenant-name': tenantName,
      },
      withCredentials: true,
    }
  );
};

export const deleteStore = (store_id: string, tenantName: string) => {
  return jwtInterceptor.delete(`${server}/stores/${store_id}`, {
    headers: {
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

export const getStoreHours = (store_id: string, tenantName: string) => {
  return jwtInterceptor.get(
    `${server}/opening-hours/stores/${store_id}/opening-hours`,
    {
      headers: {
        'Content-Type': 'application/json',
        'x-tenant-name': tenantName,
      },
      withCredentials: true,
    }
  );
};

// search appointment
export const searchAppointmentApi = (agentId: string, query: string) => {
  return jwtInterceptor.get(
    `${server}/agent/appointment/search?agentId=${agentId}&q=${query}`,
    {
      withCredentials: true,
    }
  );
};

// get pos intergation details for store
export const getPosIntegrationDataApi = (tenantName: string) => {
  return jwtInterceptor.get(
    `${server}/stores/pos-integrations?tenantName=${tenantName}`,
    {
      headers: {
        'x-tenant-name': tenantName,
      },
      withCredentials: true,
    }
  );
};

// get reservations
export const getUpcomingReservationsApi = ({
  page,
  limit,
  restaurantId,
  userId,
}: {
  page: number;
  limit: number;
  restaurantId: string;
  userId: string;
}) => {
  const url = `${server}/reservation/upcoming/${restaurantId}?page=${page}&limit=${limit}&userId=${userId}`;
  return jwtInterceptor.get(url, {
    withCredentials: true,
  });
};

// get history reservations
export const getHistoryReservationsApi = ({
  page,
  limit,
  startDate,
  endDate,
  restaurantId,
  userId,
}: {
  page: number;
  limit: number;
  startDate: string;
  endDate: string;
  restaurantId: string;
  userId: string;
}) => {
  const url = `${server}/reservation/history?rgRestaurantId=${restaurantId}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&userId=${userId}`;
  return jwtInterceptor.get(url, { withCredentials: true });
};

export const updateReserationStatusApi = (
  reservationId: string,
  status: number
) => {
  return jwtInterceptor.put(
    `${server}/reservation/${reservationId}`,
    {
      tpReservationStatus: status,
    },
    {
      withCredentials: true,
    }
  );
};

export const cancelReservationApi = (data: {
  tpGuestPhoneNumber: string;
  rgReservationId: string;
  tpReservationId: string;
  cancelReason: string;
}) => {
  return jwtInterceptor.post(
    `${server}/reservation/cancel`,
    {
      rgRestaurantId: '65a00e2134d73678b7f8d610',
      tpReservationStatus: 10,
      reason: data.cancelReason,
      ...data,
    },
    {
      withCredentials: true,
    }
  );
};

export const getReservationSlotsApi = (
  rgRestaurantId: string,
  date: string
) => {
  return jwtInterceptor.post(
    `${server}/reservation/outlet/inventory`,
    {
      rgRestaurantId,
      date,
    },
    {
      withCredentials: true,
    }
  );
};

export const getReservationStoresApi = () => {
  return jwtInterceptor.get(`${server}/assistant/reservation-flow`, {
    withCredentials: true,
  });
};

export const getFaqByAssistantIdApi = (
  assistantId: string,
  tenantName: string
) => {
  return jwtInterceptor.get(`${server}/assistant/faq/${assistantId}`, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-name': tenantName,
    },
  });
};

export const deleteFaqByIdApi = (id: string) => {
  return jwtInterceptor.delete(`${server}/assistant/delete-faq?id=${id}`, {
    withCredentials: true,
  });
};

export const createFaqApi = (data: {
  id: number;
  question?: string;
  answer?: string;
}) => {
  return jwtInterceptor.post(`${server}/assistant/create-faq`, data, {
    withCredentials: true,
  });
};

export const createStoreKnowledgeApi = (data: IStoreKnowledgeRequest) => {
  return jwtInterceptor.post(`${server}/store/knowledge`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const editStoreKnowledgeApi = (data: {
  storeId: string;
  id: string;
  question: string;
  answer: string;
}) => {
  return jwtInterceptor.put(`${server}/store/editknowledge`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const deleteStoreKnowledgeApi = (data: {
  method: string;
  storeId: string;
  id: string;
}) => {
  return jwtInterceptor.delete(`${server}/store/deleteknowledge`, {
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    withCredentials: true,
  });
};

export const saveAgentKnowledgeBaseApi = (
  formData: ISaveStore,
  tenantName: string
) => {
  return jwtInterceptor.post(`${server}/stores/saveStore`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'X-Tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

export const agentChatSimulation = (formData: AgentChatSimulation) => {
  return jwtInterceptor.post(`${pythonServer}/simulate`, formData, {
    headers: {
      accept: 'application/json',
    },
    withCredentials: true,
  });
};

export const getAllOrdersApi = ({
  startDate,
  endDate,
  page = 1,
  limit = 10,
  userId,
}: {
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  userId: string;
}) => {
  return jwtInterceptor.get(`${server}/all-orders`, {
    params: {
      startDate,
      endDate,
      page,
      limit,
      userId,
    },
    headers: {
      accept: 'application/json',
    },
    withCredentials: true,
  });
};

export const getTmBillBrandInfoApi = (
  tenantName: string,
  tmBillBrandShortName: string
) => {
  return jwtInterceptor.get(`${server}/brands/brand-info`, {
    params: {
      tenant_name: tenantName,
      brand_code: tmBillBrandShortName,
    },
    headers: {
      accept: 'application/json',
    },
    withCredentials: true,
  });
};

export const getTmBillMenuApi = (
  tenantName: string,
  tmBillBrandShortName: string,
  storeId: string
) => {
  return jwtInterceptor.get(`${server}/menu/tmbill/generate-menu-brand-name`, {
    params: {
      tenant_name: tenantName,
      brand_code: tmBillBrandShortName,
      store_id: storeId,
    },
    headers: {
      accept: 'application/json',
    },
    withCredentials: true,
  });
};

export const createWebhookFunctionApi = (functionData: ICreateFunction) => {
  return jwtInterceptor.post(
    `${server}/functions/createFunction`,
    functionData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const updateWebhookFunctionApi = (
  agentId: string,
  functionName: string,
  updateData: Partial<ICreateFunction>
) => {
  return jwtInterceptor.put(
    `${server}/functions/updateFunction/${agentId}/${functionName}`,
    updateData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const deleteWebhookFunctionApi = (
  agentId: string,
  functionName: string
) => {
  return jwtInterceptor.delete(
    `${server}/functions/deleteFunction/${agentId}/${functionName}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const testWebhookFunctionApi = (
  agentId: string,
  functionName: string,
  parameters: Record<string, any>
) => {
  return jwtInterceptor.post(
    `${server}/functions/testFunction`,
    {
      agentId,
      functionName,
      parameters,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const createWebFormApi = (formData: ICreateWebForm) => {
  return jwtInterceptor.post(`${server}/functions/createWebform`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const updateWebFormApi = (
  agentId: string,
  functionName: string,
  formData: Partial<ICreateWebForm>
) => {
  return jwtInterceptor.put(
    `${server}/functions/updateWebform/${agentId}/${functionName}`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const deleteWebFormApi = (agentId: string, functionName: string) => {
  return jwtInterceptor.delete(
    `${server}/functions/deleteWebform/${agentId}/${functionName}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const submitWebFormApi = (
  agentId: string,
  functionName: string,
  formData: Record<string, any>
) => {
  return jwtInterceptor.post(
    `${server}/functions/submitWebform/${agentId}/${functionName}`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// Multilingual API

export const getSTTVoicesApi = () => {
  return jwtInterceptor.get(`${server}/voices/get-stt`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getCompatibleServicesApi = (sttProvider: string) => {
  return jwtInterceptor.get(`${server}/voices/compatible-services`, {
    params: {
      stt_provider: sttProvider,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getVoicesForMultilingualApi = (params: {
  stt_provider: string;
  language: string;
  tts_service: string;
}) => {
  return jwtInterceptor.get(`${server}/voices/voices`, {
    params,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const saveWhatsappDetails = (data: ISaveWhatsappDetails) => {
  return jwtInterceptor.post(`${server}/whatsapp/save-whatsapp-details`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getPosConfigApi = () => {
  return jwtInterceptor.get(`${server}/pos-config/get`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getWhatsappClientsChat = (whatsappPhonenumberId: string) => {
  return jwtInterceptor.get(`${server}/whatsapp/get-clients-chat`, {
    params: {
      whatsappPhonenumberId,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getAgentMemories = (params: {
  agentId: string;
  startDate?: string;
  endDate?: string;
}) => {
  return jwtInterceptor.get(`${server}/memory/agno-memories`, {
    params: {
      agent_id: params.agentId,
      start_date: params.startDate,
      end_date: params.endDate,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const deleteAgentMemoryById = (id: string) => {
  return jwtInterceptor.delete(`${server}/memory/agno-memories-by-id`, {
    params: {
      id,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getAgentSummaryApi = (chatId: string) => {
  return jwtInterceptor.get(`${server}/agent/summary`, {
    params: {
      chatId,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getAvaiablePhoneNumbers = () => {
  return jwtInterceptor.get(`${server}/numbers/getNumbers`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getSubaccountNumbersApi = () => {
  return jwtInterceptor.get(`${server}/numbers/getSubaccountNumbers`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// remove agent from phone number
export const removeAgentFromPhoneNumberApi = (formData: {
  phoneNumber: string;
  type: 'trial' | 'prod';
}) => {
  return jwtInterceptor.post(
    `${server}/numbers/removeAgentFromPhoneNumber`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// update agent template
export const updateAgentTemplateApi = (formData: {
  agentId: string;
  templateId: string;
}) => {
  return jwtInterceptor.post(`${server}/agent/updateTemplate`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

// enhance system prompt
export const enhanceSystemPromptApi = (formData: {
  template_prompt: string;
  scenarios: {
    type: 'use_case' | 'call_recording' | 'transcript';
    title: string;
    content: string | string[];
  }[];
  agent_type?: string;
}) => {
  return jwtInterceptor.post(`${agenticServer}/api/optimize-prompt`, formData, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const saveConversationFlowApi = (formData: ISaveConversationFlow) => {
  return jwtInterceptor.post(
    `${server}/conversationFlow/saveconversationflow`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getConversationFlowsApi = (agentId: string) => {
  return jwtInterceptor.get(
    `${server}/conversationFlow/getconversationflows?agentId=${agentId}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getAllConversationFlowVersionsApi = (
  agentId: string,
  fromDate: string,
  toDate: string
) => {
  return jwtInterceptor.get(
    `${server}/conversationflow/getallconversationflowversions?agentId=${agentId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const existingConversationFlowVersionApi = (
  versionId: string,
  agentId: string
) => {
  return jwtInterceptor.post(
    `${server}/conversationflow/newversion`,
    {
      versionId,
      agentId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const addConversationFlowLabelApi = (
  versionId: string,
  label: string[]
) => {
  return jwtInterceptor.post(
    `${server}/conversationflow/addconversationflowlabel`,
    {
      versionId,
      label,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getWindmillFlowsApi = () => {
  return jwtInterceptor.get(`${server}/windmill/flows/list`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getWindmillSingleFlowApi = (flowPath: string) => {
  return jwtInterceptor.get(`${server}/windmill/flows/get/${flowPath}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${windmillApiAuthKey}`,
    },
    withCredentials: true,
  });
};

// Run Windmill Workflow
export const runWindmillWorkflowApi = (flowPath: string, body: any = {}) => {
  return jwtInterceptor.post(
    `${server}/windmill/jobs/run/f/${flowPath}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${windmillApiAuthKey}`,
      },
      withCredentials: true,
    }
  );
};

// Get Windmill Script Details
export const getWindmillScriptApi = (scriptPath: string) => {
  return jwtInterceptor.get(`${server}/windmill/scripts/get/p/${scriptPath}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${windmillApiAuthKey}`,
    },
    withCredentials: true,
  });
};

export const getWindmillJobsApi = (flowPath: string) => {
  const apiUrl = `${server}/windmill/jobs/list?script_path_start=${encodeURIComponent(flowPath)}&job_kinds=flow`;
  return jwtInterceptor.get(apiUrl, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${windmillApiAuthKey}`,
    },
    withCredentials: true,
  });
};

export const getWindmillJobDetailsApi = (jobId: string) => {
  const apiUrl = `${server}/windmill/jobs_u/get/${jobId}`;

  return jwtInterceptor.get(apiUrl, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${windmillApiAuthKey}`,
    },
    withCredentials: true,
  });
};

export const updatePlivoNumberUrlApi = ({
  phoneNumber,
  newUrl,
  provider,
}: {
  phoneNumber: string;
  newUrl: string;
  provider: string;
}) => {
  return jwtInterceptor.post(
    `${server}/numbers/updateUrl?provider=${provider}`,
    {
      phoneNumber,
      newUrl,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getVoiceUrlApi = ({
  phoneNumber,
  provider,
}: {
  phoneNumber: string;
  provider: string;
}) => {
  return jwtInterceptor.get(
    `${server}/numbers/get-voice-url?provider=${provider}&phoneNumber=${encodeURIComponent(phoneNumber)}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getAgentToolsApi = () => {
  return jwtInterceptor.get(`${server}/agent/tools`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const createAgentToolApi = ({
  name,
  definition,
}: {
  name: string;
  definition: UltravoxToolDefinition;
}) => {
  return jwtInterceptor.post(
    `${server}/agent/tools/create`,
    {
      name,
      definition,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const updateAgentToolApi = ({
  toolId,
  name,
  definition,
}: {
  toolId: string;
  name: string;
  definition: UltravoxToolDefinition;
}) => {
  return jwtInterceptor.put(
    `${server}/agent/tools/${toolId}`,
    {
      name,
      definition,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const deleteAgentToolApi = (toolId: string) => {
  return jwtInterceptor.delete(`${server}/agent/tools/${toolId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const getAgentToolApi = (toolId: string) => {
  return jwtInterceptor.get(`${server}/agent/tools/${toolId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const updateUserHideSectionsApi = (hideSections: HideSectionsConfig) => {
  return jwtInterceptor.post(
    `${server}/user/settings/hide-sections`,
    { hideSections },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getHotelogixSetupApi = (storeId: string, tenantName: string) => {
  return jwtInterceptor.get(
    `${server}/assistant/hotelogix-setup/?storeId=${encodeURIComponent(storeId)}&tenantName=${encodeURIComponent(tenantName)}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const getRazorpaySetupForAgentApi = (agentId: string) => {
  const params = new URLSearchParams();
  params.set('agentId', agentId);

  return jwtInterceptor.get(
    `${server}/assistant/razorpay-setup?${params.toString()}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const upsertRazorpaySetupForAgentApi = (payload: {
  agentId: string;
  razorpayKeyId: string;
  razorpayKeySecret: string;
}) => {
  return jwtInterceptor.post(`${server}/assistant/razorpay-setup`, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};

export const disconnectRazorpaySetupForAgentApi = (agentId: string) => {
  const params = new URLSearchParams();
  params.set('agentId', agentId);

  return jwtInterceptor.delete(
    `${server}/assistant/razorpay-setup?${params.toString()}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const disconnectHotelogixSetupApi = (
  storeId: string,
  tenantName: string
) => {
  return jwtInterceptor.delete(
    `${server}/assistant/hotelogix-setup/?storeId=${encodeURIComponent(storeId)}&tenantName=${encodeURIComponent(tenantName)}`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

export const disconnectPosIntegrationsApi = ({
  tenantName,
  storeId,
  posName,
}: {
  tenantName: string;
  storeId?: string;
  posName?: string;
}) => {
  const params = new URLSearchParams();
  params.set('tenantName', tenantName);
  if (storeId) params.set('storeId', storeId);
  if (posName) params.set('posName', posName);

  return jwtInterceptor.delete(`${server}/stores/pos-integrations?${params}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-name': tenantName,
    },
    withCredentials: true,
  });
};

// Logo Upload - POST /logo/upload
export const uploadLogoApi = (formData: FormData) => {
  return jwtInterceptor.post(`${server}/logo/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  });
};

// Get User Logos - GET /logo/user/logo
export const getUserLogosApi = () => {
  return jwtInterceptor.get(`${server}/logo/user/logo`, {
    withCredentials: true,
  });
};

// Get Logo File from S3 - GET /logo/file/
export const getLogoFileApi = () => {
  return jwtInterceptor.get(`${server}/logo/file/`, {
    withCredentials: true,
  });
};

// Update Logo Metadata - PUT /logo/:id
export const updateLogoMetadataApi = (
  id: string,
  data: { userId: string; title: string; subtitle?: string }
) => {
  return jwtInterceptor.put(`${server}/logo/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
};

// Replace Logo File - PUT /logo/replace/:id
export const replaceLogoFileApi = (id: string, formData: FormData) => {
  return jwtInterceptor.put(`${server}/logo/replace/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  });
};

// Process Call Evaluation - POST /api/v1/call-evaluations/processCallEvaluation
export const processCallEvaluationApi = ({
  agentId,
  storeName,
  transcription_service,
  GEMINI_TRANSCRIPTION_MODEL,
  OPENAI_TRANSCRIPTION_MODEL,
  GPT_ANALYSIS_MODEL,
  recorded_on,
  max_workers,
  batch_wait_time,
  audioFiles,
}: IProcessCallEvaluation) => {
  const formData = new FormData();
  formData.append('agentId', agentId);
  formData.append('storeName', storeName);
  formData.append('transcription_service', transcription_service);

  // Append the correct transcription model based on service
  if (transcription_service === 'gemini' && GEMINI_TRANSCRIPTION_MODEL) {
    formData.append('GEMINI_TRANSCRIPTION_MODEL', GEMINI_TRANSCRIPTION_MODEL);
  } else if (transcription_service === 'openai' && OPENAI_TRANSCRIPTION_MODEL) {
    formData.append('OPENAI_TRANSCRIPTION_MODEL', OPENAI_TRANSCRIPTION_MODEL);
  }

  formData.append('GPT_ANALYSIS_MODEL', GPT_ANALYSIS_MODEL);
  formData.append('recorded_on', recorded_on);
  formData.append('max_workers', max_workers);
  formData.append('batch_wait_time', batch_wait_time);

  // Append each audio file with the same key 'audioFiles'
  audioFiles.forEach(file => {
    formData.append('audioFiles', file);
  });

  return jwtInterceptor.post(
    `${server}/call-evaluations/processCallEvaluation`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
      timeout: 40 * 60 * 1000,
    }
  );
};

// Save Audio Evaluation - POST /api/v1/call-evaluations/saveaudioEvaluation?agentId={agentId}
export const saveAudioEvaluationApi = ({
  agentId,
  audioFile,
}: ISaveAudioEvaluation) => {
  const formData = new FormData();
  formData.append('agentId', agentId);
  formData.append('audioFile', audioFile);

  return jwtInterceptor.post(
    `${server}/call-evaluations/saveaudioEvaluation?agentId=${agentId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    }
  );
};

// Get Audio Evaluation Files - GET /api/v1/call-evaluations/getaudioEvaluation/{agentId}
export const getAudioEvaluationFilesApi = ({
  queryKey,
}: IGetAudioEvaluationFiles) => {
  const { agentId } = queryKey[1];
  return jwtInterceptor.get(
    `${server}/call-evaluations/getaudioEvaluation/${agentId}`,
    {
      withCredentials: true,
    }
  );
};

// Delete Logo - DELETE /logo/:id
export const deleteLogoApi = (id: string, userId: string) => {
  return jwtInterceptor.delete(`${server}/logo/${id}`, {
    data: { userId },
    withCredentials: true,
  });
};

export const scheduleUvOutboundCallApi = (
  formData: IScheduleUvOutboundCall
) => {
  return jwtInterceptor.post(
    `${server}/outbound-call/batch-schedule-calls`,
    formData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// ==================== Google Drive Integration APIs ====================

export const getGoogleDriveAuthUrl = async (
  agentId: string,
  returnUrl?: string
) => {
  const response = await jwtInterceptor.get(`${server}/drive/oauth/initiate`, {
    params: { agentId, ...(returnUrl && { returnUrl }) },
    withCredentials: true,
  });
  return response.data;
};

export const getGoogleDriveStatus = async (agentId: string) => {
  const response = await jwtInterceptor.get(`${server}/drive/status`, {
    params: { agentId },
    withCredentials: true,
  });
  return response.data;
};

export const getGoogleDriveFolders = async (agentId: string) => {
  const response = await jwtInterceptor.get(`${server}/drive/folders`, {
    params: { agentId },
    withCredentials: true,
  });
  return response.data;
};

export const getGoogleDriveSheetsFiles = async (
  agentId: string,
  folderId: string
) => {
  const response = await jwtInterceptor.get(`${server}/drive/sheets-files`, {
    params: { agentId, folderId },
    withCredentials: true,
  });
  return response.data;
};

export const getGoogleDriveSheetsInSpreadsheet = async (
  spreadsheetId: string,
  agentId: string
) => {
  const response = await jwtInterceptor.get(
    `${server}/drive/sheets-files/${spreadsheetId}/sheets`,
    {
      params: { agentId },
      withCredentials: true,
    }
  );
  return response.data;
};

export const saveGoogleDriveSheetsConfig = async (
  payload: IGoogleDriveConfigPayload
) => {
  const response = await jwtInterceptor.post(
    `${server}/drive/sheets-config`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
  return response.data;
};

export const disconnectGoogleDriveApi = async (agentId: string) => {
  const response = await jwtInterceptor.delete(
    `${server}/drive/oauth/disconnect`,
    {
      params: { agentId },
      withCredentials: true,
    }
  );
  return response.data;
};

// ==================== Call Evaluation APIs ====================

// Get Call Evaluation Records
export const getCallEvaluationRecordsApi = async (params: {
  storeName?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}) => {
  const queryParams: any = {
    startDate: params.startDate,
    endDate: params.endDate,
    limit: params.limit || 100,
    offset: params.offset || 0,
  };

  // Only add storeName if it's provided and not "all"
  if (params.storeName && params.storeName !== 'all') {
    queryParams.storeName = params.storeName;
  }

  const response = await jwtInterceptor.get(
    `${server}/call-evaluations/getcallEvaluations`,
    {
      params: queryParams,
      withCredentials: true,
    }
  );

  return response.data;
};

// Get AI-Generated Insights
export const getCallEvaluationInsightsApi = async (params: {
  storeName?: string;
  startDate?: string;
  endDate?: string;
}) => {
  const queryParams: any = {
    startDate: params.startDate,
    endDate: params.endDate,
  };

  // Only add storeName if it's provided and not "all"
  if (params.storeName && params.storeName !== 'all') {
    queryParams.storeName = params.storeName;
  }

  const response = await jwtInterceptor.post(
    `${server}/call-evaluations/sendEvaluationsToInsights`,
    queryParams,
    {
      withCredentials: true,
    }
  );

  return response.data;
};

// Get HubSpot contacts (for Campaign page)
export const getHubspotContacts = async (
  page = 1,
  limit = 50,
  agentId?: string,
  source?: string
) => {
  const response = await jwtInterceptor.get(`${server}/hubspot-crm/contacts`, {
    params: {
      page,
      limit,
      ...(agentId && { agentId }),
      ...(source && { source }),
    },
    withCredentials: true,
  });
  return response.data;
};

// Create HubSpot campaign
export const createHubspotCampaign = async (payload: {
  agentId: string;
  contactIds: string[];
  campaignName: string;
  description?: string;
  source?: string;
}) => {
  const response = await jwtInterceptor.post(
    `${server}/hubspot-crm/create-campaign`,
    payload,
    { withCredentials: true }
  );
  return response.data;
};

// Update HubSpot CRM config
export const updateHubspotCrmConfig = async (payload: {
  agentId: string;
  hubspotConfig: {
    apiKey: string;
    enabled: boolean;
    syncEnabled: boolean;
  };
}) => {
  const token = localStorage.getItem('userToken');
  const response = await jwtInterceptor.put(
    `${server}/hubspot-crm/config`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// Sync HubSpot CRM data for an agent
export const syncHubspotCrm = async (agentId: string, source?: string) => {
  const token = localStorage.getItem('userToken');
  const response = await jwtInterceptor.post(
    `${server}/hubspot-crm/sync`,
    { agentId, ...(source && { source }) },
    {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// Disconnect HubSpot CRM for an agent
export const disconnectHubspotCrm = async (agentId: string) => {
  const token = localStorage.getItem('userToken');
  const response = await jwtInterceptor.post(
    `${server}/hubspot-crm/disconnect`,
    { agentId },
    {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// Get Customers by Agent
export const getCustomersByAgent = async (
  agentId: string,
  page = 1,
  limit = 50
) => {
  const response = await jwtInterceptor.get(`${server}/alliance-member/agent`, {
    params: {
      agentId,
      page,
      limit,
    },
    withCredentials: true,
  });

  return response.data;
};

// Save Call Forwarding Rules
export const saveCallForwardingRulesApi = async (
  formData: ISaveCallForwardingRules
) => {
  const response = await jwtInterceptor.post(
    `${server}/call-forwarding-rule/save`,
    formData,
    {
      withCredentials: true,
    }
  );
  return response.data;
};

// Get Call Forwarding Rules
export const getCallForwardingRulesApi = async (agentId: string) => {
  const response = await jwtInterceptor.get(
    `${server}/call-forwarding-rule/get`,
    {
      params: { agentId },
      withCredentials: true,
    }
  );
  return response.data;
};

// Get Eval Config Prompts
export const getEvalConfigPromptsApi = async (agentId: string) => {
  return jwtInterceptor.get(`${server}/evaluation-prompts/get/${agentId}`, {
    withCredentials: true,
  });
};

// Update Eval Config Prompts
export const updateEvalConfigPromptsApi = async ({
  agentId,
  BUILD_PAYLOAD_FOR_GPT,
  GEMINI_DIARIZATION_PROMPT,
  GPT_ANALYSIS_PROMPT,
}: IUpdateEvalConfigPrompts) => {
  return jwtInterceptor.post(
    `${server}/evaluation-prompts/save`,
    {
      agentId,
      BUILD_PAYLOAD_FOR_GPT,
      GEMINI_DIARIZATION_PROMPT,
      GPT_ANALYSIS_PROMPT,
    },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
};

// ==================== Billing APIs ====================

// Get billing configuration
export const getBillingConfigApi = () => {
  return jwtInterceptor.get(`${server}/billing/config`, {
    withCredentials: true,
  });
};

// Create/Update billing configuration
export const saveBillingConfigApi = (configData: IBillingConfig) => {
  return jwtInterceptor.post(`${server}/billing/config`, configData, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
};

// Get invoices
export const getInvoicesApi = (params: IInvoiceQuery) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) queryParams.append(key, String(value));
  });
  return jwtInterceptor.get(
    `${server}/billing/invoices${queryParams.toString() ? `?${queryParams.toString()}` : ''}`,
    { withCredentials: true }
  );
};

// Get single invoice
export const getInvoiceApi = (invoiceId: string) => {
  return jwtInterceptor.get(`${server}/billing/invoice/${invoiceId}`, {
    withCredentials: true,
  });
};

// Generate invoice
export const generateInvoiceApi = (params: IGenerateInvoice) => {
  return jwtInterceptor.post(`${server}/billing/invoice/generate`, params, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
};

export const downloadInvoicePdfApi = (invoiceId: string) => {
  return jwtInterceptor.get(
    `${server}/billing/invoice/${invoiceId}/download-pdf`,
    {
      responseType: 'blob',
      withCredentials: true,
    }
  );
};

// ==================== OneDrive Integration APIs ====================

export const getOneDriveAuthUrl = async (
  agentId: string,
  returnUrl?: string
) => {
  const response = await jwtInterceptor.get(`${server}/onedrive/auth-url`, {
    params: { agentId, ...(returnUrl && { returnUrl }) },
    withCredentials: true,
  });
  return response.data;
};

export const getOneDriveStatus = async (agentId: string) => {
  const response = await jwtInterceptor.get(`${server}/onedrive/status`, {
    params: { agentId },
    withCredentials: true,
  });
  return response.data;
};

export const getOneDriveFiles = async (agentId: string) => {
  const response = await jwtInterceptor.get(`${server}/onedrive/files`, {
    params: { agentId },
    withCredentials: true,
  });
  return response.data;
};

export const getOneDriveSheets = async (fileId: string, agentId: string) => {
  const response = await jwtInterceptor.get(
    `${server}/onedrive/files/${fileId}/sheets`,
    {
      params: { agentId },
      withCredentials: true,
    }
  );
  return response.data;
};

export const saveOneDriveConfig = async (payload: {
  agentId: string;
  driveId: string;
  fileId: string;
  fileName: string;
  sheetId: string;
  sheetName: string;
  syncFrequency: string;
  status: string;
  filterRules: any[];
}) => {
  const response = await jwtInterceptor.post(
    `${server}/onedrive/config`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
  return response.data;
};

export const disconnectOneDriveApi = async (
  agentId: string,
  driveId?: string
) => {
  const response = await jwtInterceptor.delete(
    `${server}/onedrive/disconnect`,
    {
      params: { agentId, ...(driveId && { driveId }) },
      withCredentials: true,
    }
  );
  return response.data;
};

// Update invoice status
export const updateInvoiceStatusApi = ({
  invoiceId,
  status,
  paymentMethod,
  paymentReference,
}: IUpdateInvoiceStatus) => {
  return jwtInterceptor.patch(
    `${server}/billing/invoice/${invoiceId}/status`,
    { status, paymentMethod, paymentReference },
    { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
  );
};

// Delete invoice
export const deleteInvoiceApi = (invoiceId: string) => {
  return jwtInterceptor.delete(`${server}/billing/invoice/${invoiceId}`, {
    withCredentials: true,
  });
};

// Get invoice summary
export const getInvoiceSummaryApi = () => {
  return jwtInterceptor.get(`${server}/billing/invoice/summary`, {
    withCredentials: true,
  });
};

export const auditCallApi = ({
  callId,
  agentId,
}: {
  callId: string;
  agentId: string;
}) => {
  return jwtInterceptor.post(
    `${agentLightingServer}/update_prompt`,
    { call_id: callId, agent_id: agentId },
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );
};
